import { render, staticRenderFns } from "./restSetting.vue?vue&type=template&id=bc170a48&scoped=true"
import script from "./restSetting.vue?vue&type=script&lang=ts"
export * from "./restSetting.vue?vue&type=script&lang=ts"
import style0 from "./restSetting.vue?vue&type=style&index=0&id=bc170a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc170a48",
  null
  
)

export default component.exports